import { render, staticRenderFns } from "./Raffle.vue?vue&type=template&id=0c047c4b&scoped=true"
import script from "./Raffle.vue?vue&type=script&lang=js"
export * from "./Raffle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c047c4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c047c4b')) {
      api.createRecord('0c047c4b', component.options)
    } else {
      api.reload('0c047c4b', component.options)
    }
    module.hot.accept("./Raffle.vue?vue&type=template&id=0c047c4b&scoped=true", function () {
      api.rerender('0c047c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/Raffle.vue"
export default component.exports